export default "__VITE_ASSET__BXjv3h49__"